import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: "",//b4b2", //iconics-web
        //clientId: "d8d3386b-e9aa-4992-ab24-3cd277869050", //sample-spa
        //clientId: "71cb7396-7e68-4937-ab1a-7bbf8e6bb901", //sample-web
        //This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/", //iconics-web 
        // tenant Id :b1385e84-5062-4882-a3e6-fc7e229a1d5d 
        //https://login.microsoftonline.com/common/oauth2/authorize
        //authority: "https://login.microsoftonline.com/7ec4b8b0-bb04-4815-9820-4beacbccc0a8", //sample-spa
        //authority: "https://login.microsoftonline.com/7ec4b8b0-bb04-4815-9820-4beacbccc0a8", //sample-web
        //Defaults to "https://login.microsoftonline.com/common" 
        redirectUri: "/auth", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "sessionStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) =>
            {
                if (containsPii)
                {
                    return;
                }
                switch (level)
                {
                    case LogLevel.Error:
                        console.error('error - ', message);
                        return;
                    case LogLevel.Warning:
                        console.warn('warn - ', message);
                        return;
                    case LogLevel.Info:
                        console.info('info - ', message);
                        return;
                    case LogLevel.Verbose:
                        console.debug('verbose - ', message);
                        return;
                    case LogLevel.Trace:
                        console.trace('trace - ', message);
                        return;
                    default:
                        console.log(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "user.read", "profile"],
    loginHint: '',
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    graphMe: {
        endpoint: "https://graph.microsoft.com/v1.0/me",
        scopes: ["openid", "user.read", "profile"],
    },
    apiHello: {
        endpoint: "http://localhost:3000/hello",
        scopes: ["openid", "user.read", "profile"], // e.g. api://xxxxxx/access_as_user
    },
}
